import { useTranslation } from 'react-i18next';
import { MoreFilters } from 'src/components/organisms/more-filters';
import { spaceTypesTranslations } from 'src/features/spaces/constants/space-types-translations';
import { SpaceType } from 'src/features/spaces/types/space-type';
import { Anchor } from 'src/types/anchor';
import { HandleChangeFilterValue } from 'src/types/handle-change-filter-value';
import { FilterGroup as IFilterGroup } from 'src/types/interfaces/filter-group';
import { Filters } from 'src/types/interfaces/filters';

interface Props {
  anchor: Anchor;
  filters: Filters;
  handleChangeFilterValue: HandleChangeFilterValue;
  resetFilters: () => void;
}

export const SpacesMoreFilters = ({
  handleChangeFilterValue,
  filters,
  resetFilters,
  anchor,
}: Props) => {
  const { t } = useTranslation(['spaces']);

  const filterGroups: IFilterGroup<SpaceType>[] = [
    {
      id: 1,
      type: 'type',
      label: t('spaces:common.type'),
      singleOption: false,
      items: Object.entries(spaceTypesTranslations).map(([key, value]) => ({
        id: key,
        label: t(value),
        value: key as SpaceType,
      })),
    },
  ];

  return (
    <MoreFilters
      anchor={anchor}
      filters={filters}
      handleChangeFilterValue={handleChangeFilterValue}
      resetFilters={resetFilters}
      filterGroups={filterGroups}
    />
  );
};
